import React, { Component } from 'react';
import classNames from 'classnames';
import { REACT_APP_GEOJSON_LOCATION } from '../../config';
import { UnitsVisibility } from './types/units-visibility';
import './toolbar.scss';

class Toolbar extends Component {
    constructor(props) {
        super(props);

        props.addTools(this);

        this.wrapperRef = React.createRef();
        this.autoCompleteWrapperRef = React.createRef();

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.setAutoCompleteWrapperRef = this.setAutoCompleteWrapperRef.bind(this);
        
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleClickOutsideAutoCompleter = this.handleClickOutsideAutoCompleter.bind(this);

        this.state = {
            isOpen: false,
            circleToolActive: false,
            polygonToolActive: false,
            searchText: '',
            defaultSearchText: '',
            searchDate: null,
            search: null,
            results: [],
            index:-1,
            isLoadingAutoCompleter: false
        }
    }

    async fetchAutoCompleter() {
        const response = await fetch(`${REACT_APP_GEOJSON_LOCATION}/autocomplete.json`);
        return await response.json();    
    }

    componentDidMount() {
        document.addEventListener('click', (e) => this.handleClickOutside(e));
        document.addEventListener('click', (e) => this.handleClickOutsideAutoCompleter(e));
    }

    close() {
        this.setState({
            isOpen: false
        });
    }
    
    toggleSelections() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', (e) => this.handleClickOutside(e));
    }

    handleClickOutside(event) {    
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
           this.close();
        }
    }

    handleClickOutsideAutoCompleter(event) {    
        if (this.autoCompleteWrapperRef.current && !this.autoCompleteWrapperRef.current.contains(event.target)) {
           this.setState({
                results:[],
                index:-1
           });
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setAutoCompleteWrapperRef(node) {
        this.autoCompleteWrapperRef = node;
    }

    resetTools() {
        this.setState({
            polygonToolActive: false,
            circleToolActive: false
        });
    }

    getSelectedLayer() {

        switch(this.props.selectionType) {
            case 'clear':
                return 'Välj urvalslager';
            case 'zip1':
                return (
                    <>Urvalslager: <strong>1-siffriga postnummer</strong></>
                );
            case 'zip2':
                return (
                    <>Urvalslager: <strong>2-siffriga postnummer</strong></>
                );
            case 'zip3':
                return (
                    <>Urvalslager: <strong>3-siffriga postnummer</strong></>
                );
            case 'zip5':
                return (
                    <>Urvalslager: <strong>5-siffriga postnummer</strong></>
                );
            case 'county':
                return (
                    <>Urvalslager: <strong>Län</strong></>
                );
            case 'municipality':
                return (
                    <>Urvalslager: <strong>Kommuner</strong></>
                );
            case 'aregion':
                return (
                    <>Urvalslager: <strong>A-regioner</strong></>
                );
            case 'postalcity':
                return (
                    <>Urvalslager: <strong>Postorter</strong></>
                );
            default:
                return 'Välj urvalslager';
        }
    }

    getTypeName(type) {
        switch (type) {
            case 'zip1':
            case 'zip2':
            case 'zip3':
            case 'zip5':
                return 'Postnummer';
            case 'county':
                return 'Län';
            case 'municipality':
                return 'Kommun';
            case 'aregion':
                return 'A-region';
            case 'postalcity':
                return 'Postort';
            default:
                return '';
        }
    }

    isTypeValidForFoodservice(type) {
        if (this.props.type !== 'foodservice') {
            return true;
        }

        return type === 'municipality' || type === 'aregion' || type === 'zip1' || type === 'zip2' || type === 'zip3' || type === 'zip5';

    }

    async doSearch(e) {

        const searchText = e.currentTarget.value;
        this.setState({
            searchText,
            defaultSearchText: searchText
        });

        if (e.currentTarget.value.length < 1) {
            this.setState({
                results: [],
                index: -1
            });

            return;
        }

        let search = this.state.search;

        if (!search) {
            this.setState({
                isLoadingAutoCompleter: true
            });

            search = await this.fetchAutoCompleter();
        }

        const fuzzy = search.map(o => {
            
            if (!this.isTypeValidForFoodservice(o.type)) {
                return {
                    ...o,
                    relevance: 0
                }
            }

            if (o.name.toLowerCase().replace(' ', '').startsWith(searchText.toLowerCase().replace(' ', ''))) {
                return {
                    ...o,
                    relevance: 1
                };
            } 
            
            if (o.name.toLowerCase().replace(' ', '').indexOf(searchText.toLowerCase().replace(' ', '')) > -1) {
                return {
                    ...o,
                    relevance: 0.5
                }
            } 
            
            return {
                ...o,
                relevance: 0
            };
        }); 

        const results = fuzzy.filter(f => f.relevance > 0).sort((a, b) => b.relevance - a.relevance).splice(0, 10);
        this.setState({
            results,
            search
        });
    }

    formatText(item) {
        if (item.type === 'zip5') {
            return `${item.name.substring(0,3)} ${item.name.substring(3)}`;
        }

        return item.name;
    }

    selectSearchedArea(obj) {
        this.setState({
            searchText: '', 
            defaultSearchText: '',
            results: [],
            index: -1
        }, () => {
            this.props.selectSearchedArea(obj);
        });
        
    }

    handleIndexChange(e) {
        if (e.keyCode === 40) {
            this.setState({
                index: this.state.index === this.state.results.length - 1 ? -1 : this.state.index+1,
                searchText: this.state.index === this.state.results.length - 1 ? this.state.defaultSearchText : this.state.results[this.state.index+1] ? this.state.results[this.state.index+1].name : this.state.searchText
            });

            return;
        }

        if (e.keyCode === 38) {
            this.setState({
                index:  this.state.index === -1 ? this.state.results.length-1 : this.state.index-1,
                searchText: this.state.index === 0 ? this.state.defaultSearchText : this.state.results[this.state.index-1] ? this.state.results[this.state.index-1].name : this.state.searchText
            });

            return;
        }

        if (e.keyCode === 13) {
            if (this.state.results[this.state.index]) {
                this.selectSearchedArea(this.state.results[this.state.index]);
            }

            return;
        }

        return;
    }

    getPlaceholderText() {
        if (this.props.type === 'foodservice') {
            return 'Sök postnr, kommun eller a-region';
        }

        return 'Sök postnummer, kommun etc.';
    }
    getFilterButtonText() {
        const unitLocalization = this.props.type === 'foodservice' ? 'enheter' : 'butiker';
        if (this.props.units.length === this.props.allUnits.length) {
            return `Filtrera ${unitLocalization}`;
        } else {
            if (this.props.unitsVisible === UnitsVisibility.AREA) {
                return <>Filter: <strong>{this.props.numberOfUnits}st</strong> {unitLocalization}</>;
            } else {
                return <>Filter: <strong>{this.props.units.length}st</strong> {unitLocalization} <strong>({this.props.numberOfUnits}st</strong> i säljdistrikt)</>;
            }
        }
    }

    render() {
        const props = this.props;

        return (
            <div className="toolbar">
                <button className={classNames({
                                'toolbar__filter-btn': true,
                                'toolbar__filter-btn--is-active': props.filterModalIsOpen
                            })} type="button" onClick={() => {        
                                this.setState({
                                    polygonToolActive: false,
                                    circleToolActive: false,
                                    houseToolActive: false
                                }, () => {
                                    props.toggleFilterModal()
                                })}}>{this.getFilterButtonText()}</button>

                <div ref={this.autoCompleteWrapperRef} className="toolbar__autocompleter">
                    <input className="toolbar__autocompleter-search" onKeyDown={(e) => this.handleIndexChange(e)} type="text" value={this.state.searchText} placeholder={this.getPlaceholderText()} onFocus={(e) => this.doSearch(e)} onChange={(e) => this.doSearch(e)} />
                    {this.state.results && this.state.results.length > 0 &&
                        <ul className="toolbar__autocompleter-results">
                            {this.state.results.map((item, i) => {
                                return (
                                    <li key={item.id} className={classNames({
                                        'toolbar__autocompleter-result-item': true,
                                        'toolbar__autocompleter-result-item--selected': i === this.state.index
                                    })}>
                                        <button type="button" onClick={() => this.selectSearchedArea(item)}>
                                            <div>{this.formatText(item)}</div> 
                                            <div className="toolbar__autocompleter-result-type">{this.getTypeName(item.type)}</div></button>
                                    </li>
                                );
                            })}
                        </ul>
                    }
                </div>
                <div ref={this.wrapperRef}>
                    <div className={classNames({
                        'toolbar__selections': true,
                        'toolbar__selections--is-open': this.state.isOpen,
                    })}>
                        <button className="toolbar__selections-selector" onClick={() => this.toggleSelections()}>{this.getSelectedLayer()}</button>
                        <div className="toolbar__selections-options">
                            <label>
                                <input type="radio" name="selection" value="clear" checked={props.selectionType === 'clear'} onChange={(e) => props.changeSelection(e)} />
                                <span>
                                    Dölj urvalslager    
                                </span>
                            </label>
                            <label className={classNames({
                                'toolbar__selections-option--selected':  this.props.hasSelectionType('zip1')
                            })}>
                                <input type="radio" name="selection" value="zip1" checked={props.selectionType === 'zip1'} onChange={(e) => props.changeSelection(e)} />
                                <span>1-siffriga postnummer</span>
                            </label>
                            <label className={classNames({
                                'toolbar__selections-option--selected':  this.props.hasSelectionType('zip2')
                            })}>
                                <input type="radio" name="selection" value="zip2" checked={props.selectionType === 'zip2'} onChange={(e) => props.changeSelection(e)} />
                                <span>2-siffriga postnummer</span>
                            </label>
                            <label className={classNames({
                                'toolbar__selections-option--selected':  this.props.hasSelectionType('zip3')
                            })}>
                                <input type="radio" name="selection" value="zip3" checked={props.selectionType === 'zip3'} onChange={(e) => props.changeSelection(e)} />
                                <span>3-siffriga postnummer</span>
                            </label>
                            <label className={classNames({
                                'toolbar__selections-option--selected':  this.props.hasSelectionType('zip5')
                            })}>
                                <input type="radio" name="selection" value="zip5" checked={props.selectionType === 'zip5'} onChange={(e) => props.changeSelection(e)} />
                                <span>5-siffriga postnummer</span>
                            </label>
                        
                            {props.type !== 'foodservice' &&
                                <label className={classNames({
                                    'toolbar__selections-option--selected':  this.props.hasSelectionType('county')
                                })}>
                                    <input type="radio" name="selection" value="county" checked={props.selectionType === 'county'} onChange={(e) => props.changeSelection(e)} />
                                    <span>Län</span>
                                </label>
                            }
                            <label className={classNames({
                                    'toolbar__selections-option--selected':  this.props.hasSelectionType('municipality')
                                })}>
                                <input type="radio" name="selection" value="municipality" checked={props.selectionType === 'municipality'} onChange={(e) => props.changeSelection(e)} />
                                <span>Kommuner</span>
                            </label>
                            <label className={classNames({
                                    'toolbar__selections-option--selected':  this.props.hasSelectionType('aregion')
                                })}>
                                <input type="radio" name="selection" value="aregion" checked={props.selectionType === 'aregion'} onChange={(e) => props.changeSelection(e)} />
                                <span>A-regioner</span>
                            </label>
                            {props.type !== 'foodservice' &&
                                <label className={classNames({
                                    'toolbar__selections-option--selected':  this.props.hasSelectionType('postalcity')
                                })}>
                                    <input type="radio" name="selection" value="postalcity" checked={props.selectionType === 'postalcity'} onChange={(e) => props.changeSelection(e)} />
                                    <span>Postorter</span>
                                </label>
                            }
                        </div>
                    </div>
                </div>
                <div className="toolbar__tools"> 
                    {props.selectionType !== 'clear' && !props.isLoading &&
                        <>
                            <button className={classNames({
                                'toolbar__tools-btn': true, 
                                'toolbar__tools-btn--polygon': true,
                                'toolbar__tools-btn--active': this.state.polygonToolActive
                            })} type="button" onClick={() => {
                                if (this.state.polygonToolActive) {
                                    this.setState({ polygonToolActive: false });
                                    props.stopDrawing();
                                } else {
                                    this.setState({
                                        polygonToolActive: true,
                                        circleToolActive: false,
                                        houseToolActive: false
                                    });
                                    props.drawPolygon();
                                }
                                }}><span>Rita polygon</span></button>
                            <button className={classNames({
                                'toolbar__tools-btn': true,
                                'toolbar__tools-btn--circle': true,
                                'toolbar__tools-btn--active': this.state.circleToolActive
                            })} type="button" onClick={() => {
                                if (this.state.circleToolActive) {
                                    this.setState({ circleToolActive: false });
                                    props.stopDrawing();
                                } else {
                                    this.setState({
                                        polygonToolActive: false,
                                        circleToolActive: true,
                                        houseToolActive: false
                                    });
                                    props.drawCircle();
                                }
                            }}><span>Rita cirkel</span></button>
                        
                        </>
                    }
                    <button className={classNames({
                        'toolbar__tools-btn': true,
                        'toolbar__tools-btn--house': true,
                        'toolbar__tools-btn--active': this.state.houseToolActive
                    })} type="button" onClick={() => {
                        this.setState({
                            polygonToolActive: false,
                            circleToolActive: false,
                            houseToolActive: !this.state.houseToolActive
                        }, () => {
                            props.toggleDrawHouse(this.state.houseToolActive);
                        });
                        
                    }}><span>Placera hus</span></button>
                    {props.undoIsActive &&
                        <button className={classNames({
                            'toolbar__tools-btn': true,
                            'toolbar__tools-btn--undo': true,
                        })} type="button" onClick={() => props.undo()}><span>Ångra</span></button>
                    }
                    
                </div>
            </div>
            
        );
    }
}

export default Toolbar;